<div class="chart-multi-line">
    <highcharts-chart 
        [Highcharts]="hc"
        [options]="chartOptions"
        (chartInstance)="chartInit($event)"
        [style.display]="'block'"
        [style.width.%]="100"
    ></highcharts-chart>
</div>
